import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {NotiThumbnailType} from './NotiThumbnailType.enum';

export const NOTI_THUMBNAIL_IMAGE_MAP: {
  [key in Exclude<
    NotiThumbnailType,
    NotiThumbnailType.ProductThumbnail
  >]: StaticImageType;
} = {
  [NotiThumbnailType.Cash]: StaticImageType.NotificationCashStatic,
  [NotiThumbnailType.Comment]: StaticImageType.NotificationCommentStatic,
  [NotiThumbnailType.Default]: StaticImageType.NotificationBiStatic,
  [NotiThumbnailType.Heart]: StaticImageType.NotificationHeartStatic,
  [NotiThumbnailType.Gift]: StaticImageType.NotificationGiftStatic,
  [NotiThumbnailType.ThumbnailOrDefault]: StaticImageType.NotificationBiStatic,
};
